export default "__VITE_ASSET__BRwSVPRx__"